import * as React from "react";
import type { SVGProps } from "react";
const SvgFolderMinus01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12.103 19.941h-7.8a2.4 2.4 0 0 1-2.4-2.4V5.26a1.2 1.2 0 0 1 1.2-1.2h5.718l2.765 2.954h8.317a1.2 1.2 0 0 1 1.2 1.2V11.4m-5.794 5.194h6.788"
    />
  </svg>
);
export default SvgFolderMinus01;
